import React from 'react';
import ScheduleList from './schedule-list';

export default function Schedule() {
  return (
      <div className="schedule">
        <ScheduleList />
      </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/schedule.js